<section class="grey-bg pkg-section" id="services">
  <div class="container">
    <div class="row package-heading">
      <div class="col-md-8 centerize-col text-center">
        <div class="section-title">
          <h2 class="brand-mark" [appSplitText]="texts.kicker"></h2>
          <h2 class="package-title" [appSplitText]="texts.title"></h2>
        </div>
        <p class="pkg-intro" appReveal="rise">{{ texts.intro }}</p>
      </div>
    </div>

    <app-package-grid [packages]="cards" variant="home"></app-package-grid>

    <p class="text-center mt-50 mb-0" appReveal="rise">
      <a class="dv-pill dv-pill--dark cta-sheen" appMagnetic [routerLink]="link('/services')">
        <span class="magnetic-label">
          {{ texts.seeMore }}
          <span class="brand-icon brand-icon--arrow dv-arrow" aria-hidden="true"></span>
        </span>
      </a>
    </p>
  </div>
</section>
